import { createListCollection, Portal, Select, Image } from '@chakra-ui/react';
import { fi, gb, i18n, sv } from '@shared';
import { useSurveyContext } from '../context/SurveyContext';

export default function SurveyLanguageSelector() {
	const { survey } = useSurveyContext();

	function handleChangeLanguage(selected: Lang): void {
		i18n.changeLanguage(selected);
	}

	const languagesCollection = createListCollection({
		items: survey.languages.map(language => ({
			label: language.toUpperCase(),
			value: language,
		})),
	});

	return (
		<Select.Root
			border={'1px #E2E2EA solid'}
			borderRadius={'8px'}
			zIndex={999}
			w={'65px'}
			size={'xs'}
			marginBottom="0"
			cursor="pointer"
			collection={languagesCollection}
			onValueChange={e => {
				handleChangeLanguage(e.value.toString() as Lang);
			}}
			closeOnSelect
		>
			<Select.HiddenSelect />
			<Select.Control backgroundColor={'transparent'} border={'none'} cursor="pointer">
				<Select.Trigger border={'none'} cursor="pointer">
					{i18n.resolvedLanguage === 'fi' ? <Image data-cy="finnishLanguage" src={fi} alt="Finnish" cursor={'pointer'} height={'15px'} /> : null}
					{i18n.resolvedLanguage === 'en' ? <Image data-cy="englishLanguage" src={gb} alt="English" cursor={'pointer'} height={'15px'} /> : null}
					{i18n.resolvedLanguage === 'sv' ? <Image data-cy="swedishLanguage" src={sv} alt="Swedish" cursor={'pointer'} height={'15px'} /> : null}
					<Select.ValueText fontSize={'14px'} fontWeight={'500'}>
						{i18n.resolvedLanguage?.toUpperCase()}
					</Select.ValueText>
				</Select.Trigger>
			</Select.Control>
			<Portal>
				<Select.Positioner zIndex={9999}>
					<Select.Content zIndex={9999}>
						{languagesCollection.items.map(item => (
							<Select.Item data-cy={`cy-language-${item.value}`} item={item} key={item.value}>
								<Select.ItemText fontSize={'14px'}>{item.label}</Select.ItemText>
								<Select.ItemIndicator />
							</Select.Item>
						))}
					</Select.Content>
				</Select.Positioner>
			</Portal>
		</Select.Root>
	);
}
